import { useState } from "react"
import { Button, Navbar, Form, InputGroup } from "react-bootstrap"
import { Search } from "react-feather"
import { NavbarUser } from "./NavbarUser"
import { useNavigate, createSearchParams } from "react-router-dom"

const NavbarComponent: React.FC = () => {
  const [query, setQuery] = useState("")
  const navigate = useNavigate()

  const performSearch = (): void => {
    const trimmedQuery = query.trim()
    if (!trimmedQuery) return

    const searchParams = { query: trimmedQuery }

    navigate({
      pathname: "/search",
      search: `?${createSearchParams(searchParams)}`,
    })

    setQuery("")
  }

  const handleButtonClick = (event: React.MouseEvent): void => {
    event.preventDefault()
    performSearch()
  }

  const handleKeyPress = (event: React.KeyboardEvent): void => {
    if (event.key === "Enter") {
      event.preventDefault()
      performSearch()
    }
  }

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setQuery(event.target.value)
  }

  return (
    <Navbar variant="light" expand className="navbar-bg">
      <Form className="d-none d-sm-inline-block">
        <InputGroup className="input-group-navbar">
          <Form.Control
            type="text"
            placeholder="Search Members"
            aria-label="Search"
            value={query}
            onChange={handleInputChange}
            onKeyDown={handleKeyPress}
          />
          <Button type="button" onClick={handleButtonClick}>
            <Search className="feather" />
          </Button>
        </InputGroup>
      </Form>

      <NavbarUser />
    </Navbar>
  )
}

export default NavbarComponent
